/**
 * ★★ WU/U3 — O ÚLTIMO UID CONHECIDO, para a renovação da cópia poder agir na INICIALIZAÇÃO.
 *
 * ⚠⚠ O problema concreto: as chaves do U3 são por uid (`odontosdr:versao-cache:{uid}`) — ★ é o
 * desenho certo, porque o computador da recepção é **compartilhado** e a cópia de uma pessoa não
 * é a da outra. ★★★ Mas a limpeza tem de acontecer **antes de o Firestore ser usado**, e nesse
 * instante o Firebase Auth **ainda não resolveu quem está logado** (ele lê o IndexedDB dele, que
 * é assíncrono).
 *
 * ★ Então o `AuthProvider` guarda o uid de quem entrou, e a inicialização lê o **último
 * conhecido**. ⚠ Na primeiríssima visita cai em `'anonimo'`, e está certo: não há cópia de
 * ninguém para renovar.
 *
 * ⚠ Só o UID — nunca nome, e-mail ou telefone. É identificador opaco, não dado de pessoa.
 */
const CHAVE = 'odontosdr:ultimo-uid';

const deposito = () => {
  try {
    return globalThis.localStorage ?? null;
  } catch {
    return null;
  }
};

export function ultimoUid() {
  try {
    return deposito()?.getItem(CHAVE) ?? null;
  } catch {
    return null;
  }
}

export function guardarUltimoUid(uid) {
  try {
    if (uid) deposito()?.setItem(CHAVE, uid);
    else deposito()?.removeItem(CHAVE);
  } catch {
    // ⚠ Navegador que não guarda: o U3 simplesmente não age. Não é erro.
  }
}
